import styled from 'styled-components';

import {
  Flex,
  icons,
} from 'web-styled';

export const Activity = styled(Flex).attrs({
  column: true,
  align: 'center',
})`
  width: 35%;
  height: 100%;
  border-left: 1px solid #e9e9ea;
`;

export const ActivityHeader = styled(Flex).attrs({
  width: '90%',
  justify: 'center',
  borderBottom: '1px solid #e9e9ea',
})``;

export const PlaneIcon = styled.div`
  width: 55px;
  height: 57px;
  background-size: cover;
  background-image: url(${icons.paperPlane});
  filter: invert(78%) sepia(5%) saturate(27%) hue-rotate(251deg) brightness(98%) contrast(107%);
`;
